// extracted by mini-css-extract-plugin
export default {"CategoryDroppable__container":"CategoryDroppable-styles__CategoryDroppable__container__FFFTR","CategoryDroppable__icon":"CategoryDroppable-styles__CategoryDroppable__icon__gqxt_"};